<template ref="userRoleCollapse">
    <el-collapse accordion>
        <div v-for="(item, index) in list" :key="index">
            <!-- 资源名称 -->
            <el-row>
                <el-col :span="24">
                    <el-collapse-item :title="item.sRoleTypeName" :name="item">
                        <!-- 权限复选框 -->
                        <td-checkbox-group
                            :allList="item.listRoleVo"
                            v-model="item.listRoleVo"
                            ref="roleCheckGroup"
                            keys="id"
                            text="roleName"
                            :labelWidth="85"
                            :overLenghOmission="true"
                            checkBoxClass="checkboxstyle"
                            @handleCheckedChange="handleCheckedGroupChange"
                        ></td-checkbox-group>
                    </el-collapse-item>
                </el-col>
            </el-row>
        </div>
    </el-collapse>
</template>
<script>
import resourceApi from '../assets/api.js';
export default {
    props: ['list','isAddData'],
    // 定义变量
    created() {
        //console.log(this.list);
    },
    data() {
        return {
            that: this,
            allList: [],
            checkList: [],
            pageInit: true,
            resInitList: [],
            returnList: []
        };
    },
    watch: {
        /* 监听数据的变化，实时生效 */
        list: {
            handler: function(newVal) {
                this.list = newVal;
            },
            deep: true
        }
    },
    methods: {
        handleCheckedGroupChange(val) {
            console.info("val===qqqqq",val);
            // item.checkList = new Array();
            // for (let i = 0; i < val.length; i++) {
            //     data.checkList.push(val[i]);
            // }
            // this.$emit('sendCheckList', val, data);
            // this.$emit('setCheckAllBtnStatus', val, data);
        }
    }
};
</script>
